module.exports = __webpack_public_path__ + "static/media/down_arrow.07bf719e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/down_arrow.svg
// module id = 985
// module chunks = 0